import request from './baiduAxios'


//用户信息查询
export const getFace = (params) => {
	return request({
		url: "/rest/2.0/face/v3/faceset/user/get",
		method: "post",
		data: params,
	});
};

//人脸注册
export const addFace = (params) => {
	return request({
		url: "/rest/2.0/face/v3/faceset/user/add",
		method: "post",
		data: params,
	});
};

//人脸更新
export const updateFace = (params) => {
	return request({
		url: "/rest/2.0/face/v3/faceset/user/update",
		method: "post",
		data: params,
	});
};


export const getBase64FromFilePath = (filePath) => {
	return new Promise((resolve, reject) => {
	    const reader = new FileReader();
	    reader.readAsDataURL(filePath);
	    reader.onload = () => {
	        resolve(reader.result.split(',')[1]);
	    };
	    reader.onerror = (error) => {
	        reject(null)
	    };
	});
}